import { useState } from 'react';
import { useUpdateOnboardingProgressMutation } from 'src/api/mutations/onboardingMutations';
import MCPConnectGuide from './MCPConnectGuide';
import RunPromptCard from './RunPromptCard';
import styles from './styles.module.scss';

type GuidePhase = 'mcp-guide' | 'prompt';

type AIWorkflowGuideProps = {
  userEmail?: string;
  onComplete?: () => void;
  onClose?: () => void;
};

const AIWorkflowGuide = ({
  userEmail,
  onComplete,
  onClose,
}: AIWorkflowGuideProps) => {
  const [phase, setPhase] = useState<GuidePhase>('mcp-guide');
  const progressMutation = useUpdateOnboardingProgressMutation();

  const handleConnected = () => {
    progressMutation.mutate({ checklist: { ai_workflow_completed: true } });
    setPhase('prompt');
  };

  const handlePromptDone = () => {
    onComplete?.();
    onClose?.();
  };

  return (
    <div className={styles.guideContainer}>
      {phase === 'mcp-guide' && <MCPConnectGuide onConnected={handleConnected} />}
      {phase === 'prompt' && (
        <RunPromptCard
          userEmail={userEmail}
          onDone={handlePromptDone}
          onSkip={onClose}
        />
      )}
    </div>
  );
};

export default AIWorkflowGuide;
